// src/components/mobile/ProfileFormMobile.jsx
import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Autocomplete,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  collection,
  query,
  where,
  onSnapshot,
  serverTimestamp,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";

import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

export default function ProfileFormMobile() {
  const { currentUser } = useAuth();
  const { translate } = useContext(LanguageContext);
  const [input, setInput] = useState("");
  const [options, setOptions] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();

  // Charger les suggestions de sociétés en temps réel
  useEffect(() => {
    const q = query(
      collection(db, "companies"),
      where("name", ">=", input),
      where("name", "<=", input + "\uf8ff")
    );
    const unsub = onSnapshot(q, (snap) => {
      setOptions(snap.docs.map((d) => d.data().name));
    });
    return unsub;
  }, [input]);

  const handleSave = async () => {
    const name = input.trim();
    if (!name) return;
    setConfirmLoading(true);

    const companyId = name;
    const companyRef = doc(db, "companies", companyId);
    const snap = await getDoc(companyRef);

    if (!snap.exists()) {
      await setDoc(companyRef, {
        name,
        memberIds: [currentUser.uid],
        invitedEmails: [],
      });
    } else {
      await updateDoc(companyRef, {
        memberIds: arrayUnion(currentUser.uid),
      });
    }

    // Enregistrer le profil utilisateur
    await setDoc(
      doc(db, "profilsUsers", currentUser.uid),
      {
        companyId,
        companyName: name,
        role: "Admin",
        joinedAt: serverTimestamp(),
      },
      { merge: true }
    );

    setConfirmLoading(false);
    navigate("/app"); // ou "/app/projects/…" selon ta logique
  };

  return (
    <Box
      sx={{
        height: "100vh",
        px: 2,
        py: 4,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        bgcolor: "background.default",
      }}
    >
      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        {translate("CompleteYourProfile")}
      </Typography>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "80%",
          }}
        >
          <Autocomplete
            freeSolo
            options={options}
            inputValue={input}
            onInputChange={(_, v) => setInput(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={translate("Company")}
                variant="outlined"
                fullWidth
              />
            )}
            sx={{ mt: 3, mb: 2 }}
          />

          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleSave}
            disabled={!input.trim() || confirmLoading}
          >
            {confirmLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              translate("Confirm")
            )}
          </Button>
        </div>
      </div>
    </Box>
  );
}
